/// <reference path="_references.ts"/>

module App {
	const
		STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg,
		ARGUMENT_NAMES = /([^\s,]+)/g;

	export function DefaultFactory(cls: Function) {
		const instance = function() {
			// the arguments require an extra parameter at the beginning for some reason
			Array.prototype.unshift.call(arguments, cls);

			const fn = Function.prototype.bind.apply(cls, arguments);

			return new fn();
		};

		instance.$inject = getParameters(cls);

		return instance;
	}

	function getParameters(fn: Function) {
		const fnStr = fn.toString().replace(STRIP_COMMENTS, '').replace(/\$wamp2/g, '$wamp');
		const result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);

		return result === null
			? []
			: result;
	}
}
